import Icon from '../components/Icon.vue'

Icon.register({
  'envelope-open': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 464c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-263.3c0-12.9 8.2-29.8 18.4-37.8 24.9-19.5 45.5-35.4 164.2-121.5 16.8-12.3 50.2-41.8 73.4-41.4 23.2-0.4 56.6 29.2 73.4 41.4 118.7 86.1 139.3 102 164.2 121.5 10.1 8 18.4 24.9 18.4 37.8v263.3zM446.3 267.4c-2.6-3.7-7.7-4.6-11.3-1.9-22.8 16.9-55.5 40.7-105.6 77.1-16.8 12.3-50.2 41.8-73.4 41.4-23.2 0.3-56.6-29.1-73.4-41.4-50.1-36.4-82.7-60.2-105.6-77.1-3.6-2.7-8.8-1.8-11.3 1.9l-9.1 13.2c-0.8 1.1-1.4 3.2-1.4 4.5 0 2.2 1.5 5.1 3.2 6.4 22.9 16.9 55.5 40.7 105.3 76.9 20.3 14.8 56.5 47.8 92.3 47.6 35.7 0.2 72-32.8 92.3-47.6 49.9-36.2 82.4-60 105.3-76.9 1.8-1.3 3.2-4.2 3.2-6.4 0-1.4-0.6-3.4-1.4-4.5z'
      }
    ]
  }
})
